export const SET_LOADING = 'SET_LOADING';
export const SET_STARTING_BASE = 'SET_STARTING_BASE';
